module.exports = __webpack_public_path__ + "img/lb1.5814a61e.jpg";